import React from "react";
import { Helmet } from "react-helmet-async";
import { useLocation } from "react-router-dom";
import { SITE, ROUTE_SEO } from "@/lib/seo";

/**
 * Per-route SEO tags — plug once at the app root and it reads the URL to
 * apply the right title/description automatically.
 * Optional props allow inline overrides for dynamic pages.
 */
export default function Seo({ title, description, image, noindex }) {
  const { pathname } = useLocation();
  const routeCfg = ROUTE_SEO[pathname] || {};
  const finalTitle = title || routeCfg.title || SITE.defaultTitle;
  const finalDesc = description || routeCfg.description || SITE.defaultDescription;
  const finalImage = image || SITE.ogImage;
  const canonical = `${SITE.url}${pathname === "/" ? "" : pathname}`;

  return (
    <Helmet>
      <title>{finalTitle}</title>
      <meta name="description" content={finalDesc} />
      <meta name="keywords" content={SITE.keywords.join(", ")} />
      <link rel="canonical" href={canonical} />
      {noindex && <meta name="robots" content="noindex,nofollow" />}

      {/* Open Graph */}
      <meta property="og:type" content="website" />
      <meta property="og:site_name" content={SITE.name} />
      <meta property="og:title" content={finalTitle} />
      <meta property="og:description" content={finalDesc} />
      <meta property="og:url" content={canonical} />
      <meta property="og:image" content={`${SITE.url}${finalImage}`} />
      <meta property="og:image:width" content="1200" />
      <meta property="og:image:height" content="630" />
      <meta property="og:locale" content="en_IN" />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={finalTitle} />
      <meta name="twitter:description" content={finalDesc} />
      <meta name="twitter:image" content={`${SITE.url}${finalImage}`} />
      <meta name="twitter:site" content={SITE.twitterHandle} />
    </Helmet>
  );
}
